import { ChildProps } from '@apollo/client/react/hoc';
// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import { Location } from 'history';

import PriceGuideToolForm from './price_guide_tool_form';
import { CorePriceGuideToolFormContainer } from '@reverbdotcom/commons/src/gql/graphql';
import { RCLoadingBars } from '@reverbdotcom/cadence/components';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

interface IExternalProps {
  cspSlug: string;
  location?: Location;
}

type IProps = ChildProps<IExternalProps, CorePriceGuideToolFormContainer.Query>;

export function PriceGuideToolFormContainer({ data, location }: IProps) {
  const { loading, csp } = data;

  return (
    <>
      {loading ? (
        <div className="d-flex fx-justify-center fx-align-center height-vh-30">
          <RCLoadingBars size="large" />
        </div>
      ) : (
        <PriceGuideToolForm
          csp={csp}
          location={location}
        />
      )}
    </>
  );
}

export const PriceGuideToolFormContainerDataFragment = gql`
  fragment PriceGuideToolFormContainerData on CSP {
    _id
    id
    title
    brand {
      _id
      id
      name
    }
    categoryRootUuid
    categoryUuids
    image(input: { transform: "card_square" }) {
      _id
      source
    }
    canonicalProducts {
      _id
      id
      finish
      model
      name
      year
    }
    slug
  }
`;

const withQuery = withGraphql<IExternalProps, CorePriceGuideToolFormContainer.Query>(
  gql`
    query Core_PriceGuideToolFormContainer($cspSlug: String) {
      csp(
        input: {
          slug: $cspSlug
        }
      ) {
        _id
        ... PriceGuideToolFormContainerData
      }
    }
    ${PriceGuideToolFormContainerDataFragment}
  `,
  {
    options: ({ cspSlug }) => {
      return {
        errorPolicy: 'all',
        ssr: false,
        variables: {
          cspSlug,
        },
      };
    },
  },
);

export default withQuery(PriceGuideToolFormContainer);
